/**
 * @module learning_content.transformer
 */
import { contentUrl } from '~/config/settings/worktango.settings';

/**
 * Transform a learning content returned by server to usable format by front-end UI.
 *
 * Learning Content API specification: https://gitlab.com/worktangocanada/pulse2.0-admin/-/blob/develop/src/api/learning-content/learning-content-specification.md
 *
 * @example
 *
 * ```json
 *  {
 *   "learningContents": [
 *     {
 *       "id": 1,
 *       "title": "Article 1",
 *       "url": "https://example.com/article-1",
 *       "imageFileName": "article-1.png",
 *       "blurb": "This is the first article",
 *       "effectiveness": 1,
 *       "categories": [1, 2, 3],
 *       "tags": [1, 2, 3],
 *       "userActivity": {
 *         "isStarred": true,
 *         "isVisited": true,
 *         "rating": 1
 *       }
 *     }
 *   ]
 * }
 * ```
 */
const learningContentFrom = (learningContent) => {
  return {
    id: learningContent?.id,
    name: learningContent?.title || learningContent?.name,
    description: learningContent?.blurb || learningContent?.blurp,
    url: learningContent?.url || learningContent?.link,
    imageFilename: learningContent?.imageFileName,
    imageUrl: learningContent?.imageFileName ? `${contentUrl}/${learningContent?.imageFileName}` : undefined,
    source: learningContent?.source?.trim(),
    contentType: learningContent?.contentType,
    effectiveness: learningContent?.effectiveness || null,
    rating: learningContent?.userActivity?.rating,
    isVisited: learningContent?.userActivity?.isVisited,
    isStarred: learningContent?.userActivity?.isStarred,
    learningTags: learningContent?.tags || [],
    categories: learningContent?.categories || [],
  };
};

export { learningContentFrom };
